module.exports = __webpack_public_path__ + "img/product-dyna-system-picture.18f5527f.png";